import clouds from "../../asset/clouds.svg";

const Indicator = () => {
  return (
    <div className="py-8 flex justify-center lg:my-[107px] md:my-[60px] mt-3 mb-[96px] overflow-hidden container mx-auto">
      <div className=" max-w-[299px]  mx-auto  relative after:bg-gradient-to-l after:from-[#D1D1D1] after:to-[#F7F7F5] after:h-px after:w-full  md:after:w-[568px] after:absolute  after:top-1/2 after:right-full   before:bg-gradient-to-r before:from-[#D1D1D1] before:to-[#F7F7F5]  before:h-px before:w-full  md:before:w-[568px] before:absolute before:top-1/2 before:left-full">
        <img
          className="absolute -z-10 md:h-[93px] md:w-[236px] w-[172px] h-[68px]"
          width={236}
          height={93}
          src={clouds}
          alt="clouds"
        />
        <p className="md:pt-[66px] pt-12 text-center text-base md:text-2xl font-medium [&_span]:text-[#888888] text-[#1C1C1C]">
          Driving <span>Growth </span>{" "}
          <span className="block">
            {" "}
            <span className="!text-[#1C1C1C]">through </span> Smart Software{" "}
          </span>
        </p>
      </div>
    </div>
  );
};

export default Indicator;
